import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from '../navbar/navbar.component';
import { NavItem } from '../navbar/navbar.interface';
import { RightNavbarComponent } from '../right-navbar/right-navbar.component';
import { Roles } from 'src/app/core/auth/roles.enum';

@Component({
  selector: 'rqa-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [CommonModule, NavbarComponent, RightNavbarComponent]
})
export class HeaderComponent {
  menuItems: NavItem[] = [
    {
      routerLink: '/',
      label: 'menu.myRqa',
      roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW]
    },
    {
      routerLink: '/orders',
      label: 'menu.orders',
      roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW, Roles.WEBRQA_VIEWER]
    },
    {
      routerLink: '/templates',
      label: 'menu.templates',
      roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW]
    },
    {
      routerLink: '/adhoc',
      label: 'menu.adhoc',
      roles: [Roles.WEBRQA_DRAW]
    },
    {
      routerLink: '/messages',
      label: 'menu.messages',
      roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW, Roles.WEBRQA_VIEWER]
    },
    {
      routerLink: '/observer',
      label: 'menu.observer',
      roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW, Roles.WEBRQA_OBSERVER, Roles.WEBRQA_VIEWER]
    },
    {
      routerLink: '/help',
      label: 'menu.help',
      roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW, Roles.WEBRQA_VIEWER, Roles.WEBRQA_OBSERVER]
    },
    {
      routerLink: '/privacy-policy',
      label: 'menu.privacyPolicy',
      roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW, Roles.WEBRQA_VIEWER, Roles.WEBRQA_OBSERVER]
    }
  ];
}
